/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

// Pages that are linked from an email and may therefore carry their destination
// through the login screen. Every other page falls back to the dashboard after
// login, so logging out of e.g. /admin/restaurant never lands back there.
export const EMAIL_DEEP_LINK_PATHS = ['/admin/policy_engine/inactivity_review'];

// The URL the browser was opened at, read once before React Router navigates
// anywhere. An emailed link is an entry URL; an in-app logout never is.
let entryTarget =
  typeof window === 'undefined'
    ? ''
    : `${window.location.pathname}${window.location.search}`;

export const isEmailDeepLinkPath = (pathname) => EMAIL_DEEP_LINK_PATHS.includes(pathname);

// Retires the entry URL on sign-out. A logout re-renders inside the SPA without
// reloading the document, so the entry URL would otherwise still match the page
// being logged out of and send the user back there after login.
export const clearEntryTarget = () => {
  entryTarget = '';
};

// True only when `target` is the URL this browser tab was opened at and no
// logout has happened since — the emailed link is honored on the trip it was
// sent for, and never again.
export const isAppEntryTarget = (target) => !!entryTarget && target === entryTarget;
